import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoAcumulado } from 'src/app/models/entities/presupuesto-acumulado';
import { PresupuestoAcumuladoMes } from 'src/app/models/entities/presupuesto-acumulado-mes';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { take } from 'rxjs/operators';


@Component({
  selector: 'grafica-avance-financiero',
  templateUrl: './grafica-avance-financiero.component.html',
  styleUrls: ['./grafica-avance-financiero.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class GraficaAvanceFinancieroComponent implements OnInit {
  @Input("mostrarTodasLasGraficas")
  public mostrarTodasLasGraficas: boolean = false;

  @Input('graficaChica')
  public graficaChica: boolean = false;

  @Input("mostrarHeader")
  public mostrarHeader: boolean = false;
  public comentariosRurales: string;
  public comentariosFederales: string;
  public data: any;
  public dataRurales: any;
  public dataFederales: any;
  public modificadosRurales: number[] = [];
  public totalesEjercidosRurales: number[] = [];
  public modificadosFederales: number[] = [];
  public totalesEjercidosFederales: number[] = [];
  public plugin = ChartDataLabels;
  public options: any;
  public fechaActual: Date = new Date();
  public meses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

  @Output()
  public pdfReadyEmitter: EventEmitter<{ comentariosRurales: string, comentariosFederales: string }> = new EventEmitter<{ comentariosRurales: string, comentariosFederales: string }>();

  public datosCargados: boolean = false;

  constructor(private lotePresupuesoService: LotePresupuestoService) {

    this.options = {
      plugins: {
        datalabels: {
          align: 'top',
          anchor: 'end',
          borderRadius: 4,
          // backgroundColor: 'black',
          color: 'black',
          font: {
            // weight: 'bold',
            size: 10
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return '$' + value;
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Millones de pesos'
          }
        }]
      },
      layout: {
        padding: {
          top: 50,
          right: 50,
          left: 50,
          bottom: 50
        }
      },
      legend: {
        position: 'bottom'
      },
      tooltips: {
        intersect: true
      },
      elements: {
        line: {
          tension: 0
        }
      }
    };
  }

  public async ngOnInit(): Promise<any> {
    this.data = {
      labels: ['0', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      datasets: []
    };

    this.dataRurales = {
      labels: ['0', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      datasets: []
    };
    this.dataFederales = {
      labels: ['0', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      datasets: []
    };

    await this.crearDatasetsRurales();
    await this.crearDatasetsFederales();

    this.datosCargados = true;
    this.pdfReadyEmitter.emit({ comentariosRurales: this.comentariosRurales, comentariosFederales: this.comentariosFederales });
  }


  public async crearDatasetsRurales(): Promise<any> {
    let lotePresupuesto: LotePresupuesto = await this.lotePresupuesoService.findByKeyCatDireccion('0').pipe(take(1)).toPromise();
    this.modificadosRurales.unshift(0);
    this.totalesEjercidosRurales.unshift(0);
    let presupuestoCaminosRurales: PresupuestoAcumulado = lotePresupuesto.lotePresupuestoAcumulado.presupuestosAcumulados.find((pa: PresupuestoAcumulado) => pa.keyPrograma === '3');
    presupuestoCaminosRurales.presupuestosAcumuladosMeses.forEach((pam: PresupuestoAcumuladoMes, i: number) => {
      if (pam.modificado !== 0) {
        this.modificadosRurales.push(this.modificadosRurales[i] + pam.modificado);
      }
      if (pam.totalEjercido !== 0) {
        this.totalesEjercidosRurales.push(this.totalesEjercidosRurales[i] + pam.totalEjercido);
      }
    });


    this.data.datasets.push({
      label: 'Modificado Caminos Rurales',
      data: this.modificadosRurales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#a12040'
    });
    this.data.datasets.push({
      label: 'Ejercido Caminos Rurales',
      data: this.totalesEjercidosRurales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#bb9767'
    });
    this.dataRurales.datasets.push({
      label: 'Modificado Caminos Rurales',
      data: this.modificadosRurales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#4371c2'
    });
    this.dataRurales.datasets.push({
      label: 'Ejercido Caminos Rurales',
      data: this.totalesEjercidosRurales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#09b03b'
    });
    this.comentariosRurales = lotePresupuesto.comentarios;
  }

  public async crearDatasetsFederales(): Promise<any> {
    let lotePresupuesto: LotePresupuesto = await this.lotePresupuesoService.findByKeyCatDireccion('1').pipe(take(1)).toPromise();
    this.modificadosFederales.unshift(0);
    this.totalesEjercidosFederales.unshift(0);
    let presupuestoCaminosRurales: PresupuestoAcumulado = lotePresupuesto.lotePresupuestoAcumulado.presupuestosAcumulados.find((pa: PresupuestoAcumulado) => pa.keyPrograma === '3');
    presupuestoCaminosRurales.presupuestosAcumuladosMeses.forEach((pam: PresupuestoAcumuladoMes, i: number) => {
      if (pam.modificado !== 0) {
        this.modificadosFederales.push(this.modificadosFederales[i] + pam.modificado);
      }
      if (pam.totalEjercido !== 0) {
        this.totalesEjercidosFederales.push(this.totalesEjercidosFederales[i] + pam.totalEjercido);
      }
    });
    this.data.datasets.push({
      label: 'Modificado Carreteras Federales',
      data: this.modificadosFederales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#4371c2'
    });
    this.data.datasets.push({
      label: 'Ejercido Carreteras Federales',
      data: this.totalesEjercidosFederales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#09b03b'
    });
    this.dataFederales.datasets.push({
      label: 'Modificado Carreteras Federales',
      data: this.modificadosFederales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#4371c2'
    });
    this.dataFederales.datasets.push({
      label: 'Ejercido Carreteras Federales',
      data: this.totalesEjercidosFederales.map(v => parseFloat(v.toFixed(2))),
      fill: false,
      borderColor: '#09b03b'
    });
    this.comentariosFederales = lotePresupuesto.comentarios;

  }


}
